import { render, staticRenderFns } from "./ContractCancellationWarning.vue?vue&type=template&id=bb1d1212&"
import script from "./ContractCancellationWarning.vue?vue&type=script&lang=js&"
export * from "./ContractCancellationWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports